import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { logError } from '@/lib/logger';

// `client` must be a module-level instance (axios/authAxios); an inline axios.create() would refetch forever.
export function useApiData(url, initialValue, client = axios) {
  const [state, setState] = useState({ url: null, data: undefined, error: null });
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    client.get(url, { signal: controller.signal })
      .then(res => setState({ url, data: res.data, error: null }))
      .catch(error => {
        if (axios.isCancel(error)) return;
        logError(`Failed to load ${url}:`, error);
        setState({ url, data: undefined, error });
      });
    return () => controller.abort();
  }, [url, client, version]);

  const reload = useCallback(() => setVersion(v => v + 1), []);

  return { data: state.data ?? initialValue, loading: state.url !== url, error: state.error, reload };
}
